import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { permissionsFieldList, addField, editField, fieldDelete } from './request';
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'permissionsId',
  align: 'center',
  width: 80,
  scopedSlots: {
    customRender: 'id'
  }
}, {
  slots: {
    title: '字段名'
  },
  dataIndex: 'field',
  align: 'center',
  scopedSlots: {
    customRender: 'field'
  }
}, {
  slots: {
    title: '字段显示名'
  },
  dataIndex: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  slots: {
    title: '排序'
  },
  dataIndex: 'sort',
  align: 'center',
  scopedSlots: {
    customRender: 'sort'
  }
}, {
  slots: {
    title: '字段配置项'
  },
  dataIndex: 'config',
  align: 'center',
  scopedSlots: {
    customRender: 'config'
  },
  ellipsis: true
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  width: 120,
  align: 'center',
  scopedSlots: {
    customRender: 'operation'
  }
}];
export default {
  data() {
    return {
      data: [],
      cacheData: [],
      columns,
      editingKey: '',
      permissionsId: '',
      dialogVisible: false
    };
  },
  methods: {
    init(val) {
      this.permissionsId = val.id;
      permissionsFieldList({
        permissionsId: val.id
      }).then(res => {
        console.log(res);
        // res.map((item,index)=>item.key=index)
        this.data = res;
        this.cacheData = res.map(item => ({
          ...item
        }));
      });
      this.dialogVisible = true;
    },
    handleChange(value, key, column) {
      console.log(value, key, column);
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    async save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      if (target && targetCache) {
        let fun = !target.id ? addField : editField;
        let addfield = await fun(target);
        target.key = addfield;
        target.id = addfield;
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = '';
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      this.editingKey = '';
      if (target) {
        Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
        delete target.editable;
        this.data = newData;
      }
    },
    del(index) {
      fieldDelete({
        permissionsFieldId: this.data[index].id
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.data.splice(index, 1);
      });
    },
    handleAdd() {
      const {
        data
      } = this;
      console.log(data);
      let key = data.length != 0 ? data[data.length - 1].key + 1 : 1;
      const newData = {
        key: key,
        permissionsId: this.permissionsId,
        field: '',
        name: '',
        sort: '',
        config: ''
      };
      this.data = [...data, newData];
      this.cacheData = this.data.map(item => ({
        ...item
      }));
      this.edit(newData.key);
    },
    handleStandardTableChange(val) {
      console.log(val);
      this.pagination = val;
    },
    handleSure() {}
  }
};